export const NoDataAvailable = () => (
  <svg width="1em" height="1em" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 12C0 5.37258 5.37258 0 12 0H28C34.6274 0 40 5.37258 40 12V28C40 34.6274 34.6274 40 28 40H12C5.37258 40 0 34.6274 0 28V12Z"
      fill={"#F4F4F5"}
    />
    <path
      d="M11.6654 20.6252H16.1881C16.7058 20.6252 17.194 20.8657 17.5095 21.276L17.79 21.6409C18.1055 22.0513 18.5937 22.2918 19.1113 22.2918H20.886C21.4037 22.2918 21.8919 22.0513 22.2074 21.6409L22.4879 21.276C22.8034 20.8657 23.2916 20.6252 23.8093 20.6252H28.332M28.3569 20.2672L25.5883 14.865C25.3031 14.3085 24.7304 13.9585 24.1051 13.9585H15.8923C15.267 13.9585 14.6943 14.3085 14.4091 14.865L11.6405 20.2672C11.5199 20.5025 11.457 20.763 11.457 21.0274V24.3752C11.457 25.2956 12.2032 26.0418 13.1237 26.0418H26.8737C27.7942 26.0418 28.5404 25.2956 28.5404 24.3752V21.0274C28.5404 20.763 28.4775 20.5025 28.3569 20.2672Z"
      stroke={"#A1A1AA"}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
)
export default NoDataAvailable
